import * as React from 'react';
import { Container, Row, Col } from "reactstrap";
import EpisodeList from "./episodeList";
import EpisodeDetail from "./episodeDetail";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons';
import { stat } from 'fs';
import { Capitalize, showAlert } from '../common/functions';

class EpisodePageComponent extends React.Component {
	state = {
		isView: false,
		selectedId: false,
		dropdownShopOpen: false,
		page: "",
		id: 0,
		title: "",
		channelId: 0
	}
	constructor(props: any) {
		super(props);
		var tokenstr = (new URLSearchParams(window.location.search)).get("page");
		let tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr === null ? 0 : parseInt(idstr);
		var idChannelstr = localStorage.getItem("channelId");
		var channelId = idChannelstr === null ? 0 : parseInt(JSON.parse(idChannelstr));
		this.state = {
			isView: false,
			selectedId: false,
			dropdownShopOpen: false,
			page: tValue,
			id: id,
			title: "Create New",
			channelId: channelId
		}
		this.handleCallbackMethod = this.handleCallbackMethod.bind(this);
	}

	componentDidMount() {
		var tokenstr = (new URLSearchParams(window.location.search)).get("page");
		let tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var idChannelstr = localStorage.getItem("channelId");
		var channelId = idChannelstr === null ? 0 : parseInt(JSON.parse(idChannelstr));
		var id = idstr === null ? 0 : parseInt(idstr);
		var pageValue = id === 0 ? tValue : "detail";

		this.setState({
			...stat,
			page: pageValue,
			id: id,
			title: "",
			isView: pageValue === "" ? true : false,
			channelId: channelId
		});

		var alertMessage = window.localStorage.getItem('alertMessage');
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem('alertMessage', "");
		}

		document.title = `${pageValue==="" ? "Episodes" : "Episode"} - Daily Audio Bible Administration`;
	}

	handleCallbackMethod(value) {
		this.setState({ title: value });
	}

	render() {
		const { title } = this.state;
		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
							{this.state.page === "add" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faMicrophone} />
										<span data-testid="episodePageTitle"> Episodes - {title != "" ? Capitalize(title) : "Create New"}</span>
									</h2>
									<hr />
									<EpisodeDetail callback={this.handleCallbackMethod} id={this.state.id} />
								</div>
							)}
							{this.state.page === "detail" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faMicrophone} />
										<span data-testid="episodePageTitle"> Episodes - {Capitalize(title)} {title.includes("Create Audio Bookmark") ? "" : "Details"}</span>
									</h2>
									<hr />
									<EpisodeDetail callback={this.handleCallbackMethod} id={this.state.id} />
								</div>
							)}
							{this.state.page === "" && this.state.isView && (<div>
								<h2>
									<FontAwesomeIcon icon={faMicrophone} />
									<span data-testid="episodePageTitle"> Episodes</span>
								</h2>
								<hr />
								<EpisodeList channelId={this.state.channelId} />
							</div>)}
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default EpisodePageComponent;